import { Injectable } from '@angular/core';
import {SearchCases} from '../models/searchcasesfilter.model'

@Injectable({
    providedIn: 'root'
  })

export class SharedService {
    public searchCaseFilter:SearchCases = new SearchCases();
    public newPopupWindow :any;
    public notificationMessage :string;

    public openPopupWindow() :any{
      let newWinPopup :any;

        if(!window.navigator.msSaveBlob){
          let isAndroid = /Android/i.test(navigator.userAgent);
          if(!isAndroid){
            newWinPopup= window.open();
            newWinPopup.document.write('Loading....');
          }         
        }

        this.newPopupWindow= newWinPopup;
    }

    public closePopupWindow() {
      if( this.newPopupWindow)
        this.newPopupWindow.close();
    }

    public displayPdf(res:any,filename:string){
      if(!filename){
        filename="file.pdf";
      }

      if(res.type!="application/pdf"){
        this.closePopupWindow();
        throw new Error("Invalid file.");
      }

      let url = window.URL.createObjectURL(new Blob([res], { type: "application/pdf" }));

      let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);


      if (window.navigator.msSaveBlob) {
        var file = new Blob([res], { type: "application/pdf" });
        window.navigator.msSaveBlob(file, filename);
      }
      else if(!isSafari) {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.click();     
        this.closePopupWindow();
      }
      else{
        this.newPopupWindow.location.href = url;
      }
    }
  }